// extracted by mini-css-extract-plugin
export default {"cls1":"VIkQLTeNGGrjB2C1BfVZ","cls2":"iFagaaMA6O9zFWP263J8 VIkQLTeNGGrjB2C1BfVZ","isTabletDown":"L1S4hgrulE734twtQvG_"};